import { UserType } from '../../entities';
import { AppSecurityRight, AssetSecurityModule, ClaimSecurityRight, ConfigurationSecurityRight, CrmSecurityRight, DashboardSecurityRight, DefectSecurityModule, JobSecurityModule, JobSecurityRight, JobTemplateSecurityRight, JobTemplatesSecurityModule, MobileTechniciansSecurityRight, SalesSecurityModule, QuoteTemplatesSecurityModule, RecurringJobSecurityModule, TaskSecurityRight, TimesheetSecurityRight, VariationSecurityModule, WorkComplianceSecurityRight, SalesSecurityRight } from '../modules';
import { SecurityRole, SecurityRoleType } from '../security.role';

export class EmployeeOperations implements SecurityRole {

    _id = 'f4c5d7c6-dc9c-44b9-97f7-a1a1400a4e50';
    system = true;
    hidden = false;
    name = SecurityRoleType.EmployeeOperations;
    type = UserType.Employee;
    description = 'Can manage customers, generate invoices and edit pricebooks';

    rights = [
        AppSecurityRight.LoginWeb,

        ConfigurationSecurityRight.AccessMetadata,
        ConfigurationSecurityRight.AccessPricing,
        ConfigurationSecurityRight.AccessTemplates,

        ConfigurationSecurityRight.ManageMetadata,
        ConfigurationSecurityRight.ManagePricing,
        ConfigurationSecurityRight.ManageTemplates,

        ConfigurationSecurityRight.AccessDocumentThemes,
        ConfigurationSecurityRight.ManageDocumentThemes,

        WorkComplianceSecurityRight.ManageCompliance,
        WorkComplianceSecurityRight.ManageComplianceRules,



        ...new JobSecurityModule().allExceptRights([JobSecurityRight.ModifyJobAfterFinalise, JobSecurityRight.ReverseWorkOrderStatus, JobSecurityRight.AccessQuote, JobSecurityRight.ManageQuote, JobSecurityRight.ModifyLockedItems]),
        ...new VariationSecurityModule().allRights,
        ...new DefectSecurityModule().allRights,

        CrmSecurityRight.CanAccess,
        CrmSecurityRight.ManageSubcontractors,
        CrmSecurityRight.ViewRecurringJobsWithinCustomers,
        CrmSecurityRight.ViewRecurringJobsWithinSites,
        CrmSecurityRight.ViewServicesWithinSites,
        ClaimSecurityRight.AccessIncomingClaims,
        ClaimSecurityRight.ManageIncomingClaims,

        ...new AssetSecurityModule().allRights,
        ...new RecurringJobSecurityModule().allRights,
        ...new JobTemplatesSecurityModule().allRights,
        ...new QuoteTemplatesSecurityModule().allRights,
        ...new SalesSecurityModule().allExceptRights([SalesSecurityRight.DeleteOpportunity]),

        ...[TimesheetSecurityRight.CanAccess, TimesheetSecurityRight.ManageMyTimesheets],

        ...[TaskSecurityRight.CanAccess, TaskSecurityRight.ManageManualTasks, TaskSecurityRight.DeleteMyTasks, TaskSecurityRight.DeleteAnyTasks],

        // DashboardSecurityRight.CanViewSystemDashboards,
        DashboardSecurityRight.CanCreateDashboards,
    ];

}

